// Ícones do módulo de conta e captura, no mesmo traço de Icons.tsx (viewBox 24, pontas redondas, aria-hidden).
const S = (d: string, w = 1.75) => () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width={w} stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path d={d} />
  </svg>
);
/** Globo: endereço público (o link temporário). */
export const IconShareLink = S("M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM3.5 12h17M12 3c2.4 2.5 3.6 5.5 3.6 9s-1.2 6.5-3.6 9c-2.4-2.5-3.6-5.5-3.6-9S9.6 5.5 12 3z");
/** Peça de quebra-cabeça: extensão do navegador. */
export const IconPuzzle = S("M9 4.5a2 2 0 1 1 4 0V6h4v4h1.5a2 2 0 1 1 0 4H17v5H6v-4.5h1.5a2 2 0 1 0 0-4H6V6h3z");
/** Celular. */
export const IconPhone = S("M7.5 3h9A1.5 1.5 0 0 1 18 4.5v15a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 19.5v-15A1.5 1.5 0 0 1 7.5 3zM11 18h2");
/** Caixa com seta para cima: folha Compartilhar. */
export const IconShareSheet = S("M12 3v12M8 7l4-4 4 4M7 11H5.5v9.5h13V11H17");
/** Envelope. */
export const IconMail = S("M3.5 6h17v12h-17zM4 6.5l8 6.5 8-6.5");
/** Monitor com ponto: aparelho pareado. */
export const IconDevice = S("M3.5 5h17v11h-17zM9 20h6M12 16v4");
/** Chave: token de API. */
export const IconKey = S("M14.5 9.5a4 4 0 1 0-3.6 4M11 13.5L4 20.5M6.5 18l2 2M9 15.5l2 2");
/** Setas em círculo: reconstruir. */
export const IconRebuild = S("M19.5 12a7.5 7.5 0 0 1-13.1 5M4.5 12a7.5 7.5 0 0 1 13.1-5M17.6 3.5V7h-3.5M6.4 20.5V17h3.5");
